import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FileUploadDropzone from "./FileUploadDropzone";
import FormControl from '@mui/material/FormControl';
import MetadataTableForUploads from "./MetadataTableForUploads";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import LinearProgress from "@mui/material/LinearProgress";
import { enqueueSnackbar } from 'notistack'
import {green, grey, red} from '@mui/material/colors';
import RenderMetadataField from "../../common/RenderMetadataField";
import {Grid} from "@mui/material";
import Paper from "@mui/material/Paper";
import ListSubheader from "@mui/material/ListSubheader/ListSubheader";
import {
    asyncForEach, getReadableFileSizeString, fetch_retry, getErrorMessageFromResponse, getFieldConfig, getErrorMessageFromResponseAsync} from "../../common/helper";
import {readFileAsyncBase64, readFileAsyncArrayBuffer, buf2Base64 } from "./helper";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const styles = theme => ({

    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    greenAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: green[500],
    },
    greyAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: grey[500],
    },
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        boxShadow: 'none'
    },
    header: {
        // paddingBottom : theme.spacing(0),
    }

});

function getColour(statusIconClass) {
    switch(statusIconClass) {
        case "redAvatar":
            return(red[500]);
        case "greenAvatar":
            return(green[500]);
        default:
            return(grey[500])
    }
}

let counterMetadataTable = 0;
function addRowIDToFile (file, defaultMetadata) {

    counterMetadataTable += 1;
    file.rowId = counterMetadataTable;

    //check if any date fields to be defaulted to today's date
    let metadata = {};
    if (defaultMetadata && Array.isArray(Object.entries(defaultMetadata))) {
        (Object.entries(defaultMetadata)).forEach(entry => {
            metadata[entry[0]] = entry[1]
        })
    }
    file.metadata = metadata;

    file.id = ""; //box id placeholder
    file.statusMessage = "";
    file.partProgress = "";
    file.useChunkApi= false;
    file.statusIcon = "file_upload";
    file.statusIconClass = "greyAvatar";
    return file
}

function MetadataStep(props) {
    let gridSize = 12;
    switch(props.maxWidth) {
        case "sm":
            gridSize = 12;
            break;
        case "md":
            gridSize = 6;
            break;
        case "lg":
            gridSize = 4;
            break;
        case "xl":
            gridSize = 3;
            break;
        default:
            gridSize = 12
    }

    return (
        <React.Fragment>
            {/*Generic Fields*/}
            {
                props.uploadConfig.genericFields.length > 0 &&

                    <React.Fragment>
                        <Grid item xs={12}>
                            <Typography variant={"subtitle2"}  className={props.classes.header}>
                                {props.uploadConfig.genericMetadataStepHeader || props.uploadConfig.genericMetadataStepHeader === "" ? props.uploadConfig.genericMetadataStepHeader : "Generic metadata"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper className={props.classes.paper} style={{textAlign: "left"}}>
                                <Grid container spacing={2}>
                                    {
                                        props.uploadConfig.genericFields.map(genericField => {
                                            const fieldValue = (props.genericMetadata[genericField.templateKey + "~" + genericField.metadataKey])? props.genericMetadata[genericField.templateKey + "~" + genericField.metadataKey] : "";
                                            return (
                                                <Grid item xs={gridSize}>
                                                    <FormControl
                                                        variant="standard"
                                                        fullWidth
                                                        style={{paddingBottom: '10px', margin: '0px'}}
                                                        key={"fc" + genericField.templateKey + "~" + genericField.metadataKey}>
                                                        <RenderMetadataField
                                                            parentClasses={props.classes}
                                                            fieldValue={fieldValue}
                                                            handleOnChange={props.handleOnChangeGenericMetadata}
                                                            metadataConfig={props.metadataConfig}
                                                            optionsConfig={props.optionsConfig}
                                                            metadataKey={genericField.metadataKey}
                                                            templateKey={genericField.templateKey}
                                                            usage={"upload"}
                                                            required={genericField.required}
                                                           // helperText={(genericField.required && (!fieldValue || fieldValue === "")) ? "Value required" : ""}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            );})
                                    }
                                </Grid>
                            </Paper>
                        </Grid>
                    </React.Fragment>
            }
            {/*Document specific fields*/}
            {
                props.fields.length > 0 && props.files.length > 0 &&
                    <React.Fragment>
                        {/*<Grid item xs={12}>*/}
                        {/*    <br/><Typography variant={"subtitle2"}>Document specific metadata</Typography>*/}
                        {/*</Grid>*/}

                        <Grid item xs={12}>
                            <MetadataTableForUploads
                                parentClasses={props.classes}
                                files={props.files}
                                fixedMetadata={props.fixedMetadata}
                                genericMetadata={props.genericMetadata}
                                handleOnChangeDocumentMetadata={props.handleOnChangeDocumentMetadata}
                                fields={props.fields}
                                metadataConfig={props.metadataConfig}
                                optionsConfig={props.optionsConfig}
                                metadataFromParentFolder={props.uploadConfig.setMetadataFromParentFolder}
                                folderDetails={props.folderDetails}
                                actionConfig={props.actionConfig}
                                extractMetadataFromFileName={props.uploadConfig.extractMetadataFromFileName}

                            />
                        </Grid>
                    </React.Fragment>
            }



        </React.Fragment>
    );
}
MetadataStep.propTypes = {
    classes: PropTypes.object.isRequired,
    updateFileList: PropTypes.func.isRequired,
    files: PropTypes.array.isRequired,
    fixedMetadata: PropTypes.object.isRequired,
    genericMetadata: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    handleOnChangeGenericMetadata: PropTypes.func.isRequired,
    handleOnChangeDocumentMetadata: PropTypes.func.isRequired,
    metadataConfig: PropTypes.object.isRequired,
    optionsConfig: PropTypes.object.isRequired,
    uploadConfig: PropTypes.object.isRequired,
    maxWidth: PropTypes.string.isRequired
};


function SelectLocalDocumentStep(props) {
    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <FileUploadDropzone
                    parentClasses={props.classes}
                    triggerParentUpdateFileList={props.updateFileList}
                    actionConfig={props.actionConfig}
                />
            </Grid>
        </Grid>
    )
}
SelectLocalDocumentStep.propTypes = {
    classes: PropTypes.object.isRequired,
    updateFileList: PropTypes.func.isRequired,
    files: PropTypes.array.isRequired,
    actionConfig: PropTypes.object.isRequired
};


function ConfirmationMessageStep(props){
    return(
        <React.Fragment>
            {(props.uploadProgress > 0 && !props.isUploadComplete) &&
                <React.Fragment>
                    <LinearProgress color = "secondary"/>

                    <ListSubheader disableSticky>Uploading {props.uploadProgress} of {props.files.length} </ListSubheader>
                </React.Fragment> }

            <List>
                {
                    props.files.map(file => {

                        const isUploading = file.statusMessage.substring(0, 9) === "Uploading";
                        const largeFileWarning = file.useChunkApi && isUploading ? (file.partProgress !== "" ? file.partProgress : "  Large file, please wait...") : "";
                        return(
                            <React.Fragment key={"frag" + file.name}>
                                <ListItem key={"li" + file.name}>
                                    <ListItemAvatar>
                                        <Avatar style={{backgroundColor: getColour(file.statusIconClass)}}>
                                            <i className='material-icons'>{file.statusIcon}</i>
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText key={"liText" + file.name }
                                                  primary={file.statusIcon === "file_upload" ?
                                                      file.name + " (" + getReadableFileSizeString(file.size) + ")":
                                                      file.name }
                                                  secondary={file.statusMessage + largeFileWarning}/>
                                </ListItem>
                            </React.Fragment>
                    )})
                }
            </List>
        </React.Fragment>
    )
}

ConfirmationMessageStep.propTypes = {
    classes: PropTypes.object.isRequired,
    files: PropTypes.array.isRequired,
    uploadProgress: PropTypes.number.isRequired,
    isUploadComplete: PropTypes.bool.isRequired,
    actionConfig: PropTypes.object.isRequired
};

function ErrorMessageStep(){
    return(
        <Typography>Error message here</Typography>
    )
}
ErrorMessageStep.propTypes = {};

function AddDocDialog (props) {

    const [maxWidth, setMaxWidth] = useState("lg")
    const [open, setOpen] = useState(true)
    const [activeStep, setActiveStep] = useState(0);
    const [genericMetadata, setGenericMetadata] = useState({})
    const [files, setFiles] = useState([])
    const [response, setResponse] = useState({success: true, message: ""})
    const [uploadProgress, setUploadProgress] = useState(0)
    const [isUploadComplete, setIsUploadComplete] = useState(false)


    const debug = window.location.pathname.toLowerCase().includes("debug")
    debug && console.log ('AddDocDialog props: ', props);


    const validateGenericFields = () => {

        let fields = props.uploadConfig.genericFields;
        let missingValues = [];

        if (fields && fields.length > 0) {
            fields.forEach(field => {
                if (field.required) {
                    if (!genericMetadata[field.templateKey + "~" + field.metadataKey]  || genericMetadata[field.templateKey + "~" + field.metadataKey].toString() === "" ) {
                        let fieldConfig = getFieldConfig(props.metadataConfig, field.templateKey, field.metadataKey);
                        if (Object.entries(fieldConfig).length > 0) {
                            missingValues.push(fieldConfig.label);
                        } else {
                            missingValues.push(field.metadataKey)
                        }
                    }
                }
            })
        }

        if (missingValues.length > 0) {
            if (missingValues.length === 1) {
                enqueueSnackbar('Please select a value for ' + missingValues.slice(-1) , {variant: 'error'});
            } else {
                enqueueSnackbar('Please select a value for ' + missingValues.slice(0, missingValues.length - 1).join(', ') + " and " + missingValues.slice(-1), {variant: 'error'});
            }
            return false;
        } else {
            return true
        }
    }

    const validateDocumentSpecificFields = () => {

        let fields = props.uploadConfig.documentSpecificFields;
        let missingValues = [];

        //loop through files
        let files = files;
        if (fields && fields.length > 0 && files && files.length > 0) {
            fields.forEach(field => {
                if (field.required) {
                    for(let i=0; i<files.length; i++) {
                        if (!files[i].metadata || Object.entries(files[i].metadata) === 0 || !files[i].metadata[field.templateKey + "~" + field.metadataKey] || files[i].metadata[field.templateKey + "~" + field.metadataKey].toString() === "") {
                            let fieldConfig = getFieldConfig(props.metadataConfig, field.templateKey, field.metadataKey);
                            if (Object.entries(fieldConfig).length > 0) {
                                missingValues.push(fieldConfig.label);
                            } else {
                                missingValues.push(field.metadataKey)
                            }
                            break;// skip to next field
                        }
                    }
                }
            })
        }

        if (missingValues.length > 0) {
            if (missingValues.length === 1) {
                enqueueSnackbar('Please select a value for ' + missingValues.slice(-1) + (files.length === 1 ? '.' : ' for each file.'), {variant: 'error'});
            } else {
                enqueueSnackbar('Please select a value for ' + missingValues.slice(0, missingValues.length - 1).join(', ') + " and " + missingValues.slice(-1) + (files.length === 1 ? '.' : ' for each file.'), {variant: 'error'});
            }
            return false;
        } else {
            return true
        }
    }

    const getFolderMetadataBox = async () => {

        const debug = window.location.pathname.toLowerCase().includes("debug");

        debug && console.log('AddDocDialog getFolderMetadataBox for parent folder');

        const pathVar = "/" + props.folderDetails.id + "/metadata";
        const url = window.REACT_APP_CONTENT_API_BASE_URL + window.REACT_APP_CONTENT_API_FOLDER_FOLDER + pathVar;

        const request = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + props.userDetails.accessToken
            },
        };

        debug && console.log ('getFolderMetadataBox url:' , url, 'request:' , request);

        await props.triggerRefreshAuthToken();
        let response = await (fetch(url,request));

        debug && console.log ('getFolderMetadataBox response = ', response);

        const responseCheck = await response.ok;

        if (responseCheck) {
            let data = await response.json();
            debug && console.log('response.json =', data);
            return data;
        } else {
            Promise.resolve(getErrorMessageFromResponse(response, 'getting folder metadata'))
                .then(message => {
                    enqueueSnackbar(message, {variant: 'error'});
                })
            return null
        }
    };

    const getFolderMetadataElastic = async () => {

        const debug = window.location.pathname.toLowerCase().includes("debug");
        const indexes = props.indexes;
        const pathVar = (indexes && indexes.length > 0 ?  "/" + indexes.toString()  : "")  + "/" + props.folderDetails.id;

        await props.triggerRefreshAuthToken();

        const url = window.REACT_APP_CASE_API_BASE_URL  + pathVar ;
        const request = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + props.userDetails.accessToken,
                "case-token": props.userDetails.caseAccessToken
            },
        };

        debug && console.log ('getFolderMetadataElastic url:' , url, 'request:' , request);

        await props.triggerRefreshAuthToken();
        let response = await (fetch(url,request));

        debug && console.log ('getFolderMetadataElastic response = ', response);

        const responseCheck = await response.ok;

        if (responseCheck) {
            let data = await response.json();
            debug && console.log('response.json =', data);
            if (Array.isArray(data)) {
                return (data[0])
            } else {
                return data;
            }

        } else {
            //response not ok
            Promise.resolve(getErrorMessageFromResponse(response, 'getting folder metadata'))
                .then(message => {
                    enqueueSnackbar(message, {variant: 'error'});
                })
            return null
        }
    }

    const processFile = async(file, parentFolderMetadata) => {
        const debug = window.location.pathname.toLowerCase().includes("debug");
        try {

            //append generic metadata
            //let genericMetadata = genericMetadata;
            let metadata = file.metadata;
            debug && console.log ("file.metadata:" , file.metadata);

            for (let propertyName in genericMetadata) {
                metadata[propertyName] = genericMetadata[propertyName];
            }

            //add any fixed metadata from config
            const fixedMetadata = props.uploadConfig.fixedMetadata;
            if (fixedMetadata) {

                for (let i = 0; i < fixedMetadata.length; ++i) {

                    let val = fixedMetadata[i].value

                    //get field config to check data type
                    let fieldConfig = getFieldConfig(props.metadataConfig, fixedMetadata[i].templateKey, fixedMetadata[i].metadataKey);

                    if (fieldConfig && fieldConfig.type === "date") {
                        let dateVal = new Date(val)
                        //dateVal.setUTCHours(0,0,0,0);
                        val = dateVal;
                    }

                    metadata[fixedMetadata[i].templateKey + "~" + fixedMetadata[i].metadataKey] = val
                }

                //Add Demo values
                // if (window.REACT_APP_ENV === 'dev') {
                //     console.log ('*** Get Demo AI Values file.name=', file.name)
                //
                //     let stub = require("../../../resources/stubs/ai_demo.json")
                //     console.log ('ai_demo', stub);
                //     if (stub[file.name] && Array.isArray(stub[file.name])) {
                //         stub[file.name].forEach(entry =>{
                //             console.log ('*** entry = ', entry);
                //             if (entry.templateKey && entry.metadataKey && entry.value) {
                //
                //                 let fieldConfig = getFieldConfig(props.metadataConfig, entry.templateKey, entry.metadataKey);
                //
                //                  console.log ('***fieldConfig=', fieldConfig)
                //                 let val = entry.value;
                //                 if (fieldConfig && fieldConfig.type === "date") {
                //                     let dateVal = new Date(val)
                //                     console.log ('dateVal=', dateVal)
                //                     //dateVal.setUTCHours(0,0,0,0);
                //                     val = dateVal;
                //                 }
                //
                //                 console.log ('*** val = ', val);
                //                 metadata[entry.templateKey + "~" + entry.metadataKey] = val
                //             }
                //         })
                //
                //     }
                //    //get ai_demo json stub
                // }


            }

            //extract templateKey & metadataKey and populate array
            let metadataArray = [];
            Object.entries(metadata).forEach(entry => {
                metadataArray.push({
                    templateKey: entry[0].split("~")[0],
                    metadataKey: entry[0].split("~")[1],
                    value: entry[1]
                });
            });

            //add any parentFolderMetadata
            parentFolderMetadata.forEach(entry => {
                metadataArray.push(entry)
            })

            debug && console.log ('metadataArray=' , metadataArray, 'uploadConfig: ', props.uploadConfig );

            let subFolders = [];
            let subFolderConfig = props.uploadConfig.subFolderConfig; //top level subfolder config

            if (subFolderConfig) {

                while(subFolderConfig.length > 0 ) {

                    debug && console.log ('subFolderConfig: ' , subFolderConfig);

                    //loop through each subFolderConfig in the subFolderConfig array
                    let valueFound = false;
                    for (let i = 0; i < subFolderConfig.length ; i++) {

                        //Check if we have a value for the metadata key provided
                        let m = subFolderConfig[i].templateKey + "~" + subFolderConfig[i].metadataKey;

                        if (file.metadata[m] ) {
                            if (file.metadata[m].toString() !== "" ) {

                                //value found so add it to subFolders array
                                subFolders.push(file.metadata[m]);

                                //found a value so drill down to next subFolderConfig level
                                subFolderConfig = subFolderConfig[i].subFolderConfig;

                                valueFound = true;
                                break;
                            }
                        }
                    }

                    //if no metadata value found after looping through the subFolderConfigs at this level
                    //then don't want to drill down any further so exit the while loop by setting subFolderConfig to []
                    if (!valueFound || ! subFolderConfig){
                        subFolderConfig = []
                    }
                }
            }

            //If adding a document from within a folder, add document to the selected folder
            let folderId = props.uploadConfig.folderId;
            if (props.folderDetails) {
                if (props.folderDetails.id) {
                    window.location.pathname.toLowerCase().includes("debug") && console.log ('props.folderDetails.id = ', props.folderDetails.id);
                    folderId = props.folderDetails.box_id ? props.folderDetails.box_id : props.folderDetails.id;
                }
            }

            let queryStr = "?folderId=" + folderId  ;

            if (props.uploadConfig.convert) {
                queryStr = queryStr + "&convert=true"
            }

            if (props.uploadConfig.ocr) {
                queryStr = queryStr + "&ocr=true"
            }

            if (props.actionConfig.audit) {
                queryStr = queryStr + "&audit=true"
            }

            if (props.uploadConfig.newVersionOnConflict) {
                queryStr = queryStr + "&newVersionOnConflict=true"
            }
            const baseUrl = props.uploadConfig.watson ? window.REACT_APP_CONTENT_API_BASE_URL_AI : window.REACT_APP_CONTENT_API_BASE_URL;
            const endpoint = props.actionConfig.customEndpoint ? props.actionConfig.customEndpoint : window.REACT_APP_CONTENT_API_DOCUMENT;
            const url = baseUrl + endpoint + queryStr;

            //If large file need to chunk content and upload in chunks

            const useChunkApiFrom = props.actionConfig.useChunkApiFrom;
            const useChunkApi = useChunkApiFrom && useChunkApiFrom > 0 && file.size > useChunkApiFrom;

            debug && console.log ('useChunkApiFrom = ', useChunkApiFrom, 'useChunkApi=', useChunkApi);

            // The direct file upload API supports files up to 50MB in size and sends all the binary data to the Box API in 1 API request.
            // The chunked upload APIs support files from 20MB in size and allow an application to upload the file in parts,
            // allowing for more control to catch any errors and retry parts individually.

            if (useChunkApi) {

                debug && console.log (' use chunked upload API, file.size=', file.size);

                let updatedFiles = [...files];
                file.useChunkApi = true ;
                setFiles((updatedFiles))

                let sessionError = false;

                //1. Create Upload Session
                let body={
                    folder_id: folderId,
                    file_size: file.size,
                    file_name: file.name
                }
                const sessionRequest = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + props.userDetails.accessToken
                    },
                    body: JSON.stringify(body)
                };
                const url = window.REACT_APP_CONTENT_API_BASE_URL + window.REACT_APP_CONTENT_API_DOCUMENT + '/chunked/upload_sessions';
                debug && console.log ('Create session url= ', url, 'BODY=', body, 'request=', sessionRequest);

                await props.triggerRefreshAuthToken();
                let sessionResponse = await (fetch_retry(url,sessionRequest,3));
                debug && console.log ('Create session response = ', sessionResponse);
                let session;
                if (sessionResponse.ok) {
                    session = await sessionResponse.json();
                    debug && console.log ('Create session response.json = ', session);
                } else {
                    sessionError = true
                    //response not ok
                    Promise.resolve(getErrorMessageFromResponse(sessionResponse, 'creating upload session'))
                        .then(message => {
                            enqueueSnackbar(message, {variant: 'error'});
                        })
                }

                if (sessionError) {
                    console.log ('sessionError.... session = ', session, 'sessionResponse=', sessionResponse);
                    if (session) {
                        debug && console.log ('return session', session)
                        return session
                    } else {
                        debug && console.log ('return sessionResponse', sessionResponse)
                        return sessionResponse
                    }

                } else {
                    //2. Upload each part
                    debug && console.log ('Upload ' + session.total_parts +' parts....');

                    //Read file
                    //const allBytes = await readFileAsyncBinary(file); //for digest
                    const bodyFull = await readFileAsyncArrayBuffer(file);  //for body
                    debug && console.log ('file.size=', file.size);

                    //initialise rangeEnd and contentRange then loop through and upload each part
                    let rangeStart = 0;
                    let rangeEnd = session.part_size-1
                    const partURL = window.REACT_APP_CONTENT_API_BASE_URL + window.REACT_APP_CONTENT_API_DOCUMENT + '/chunked/upload_sessions/' + session.id;

                    const partsArray = []
                    let partError = false

                    for (let i = 0; i < session.total_parts; i++) {

                        debug && console.log (file.name ,' upload part: ', i+1, ' of ', session.total_parts);

                        let updatedFiles = [...files];
                        let progress = i+1
                        file.partProgress =  '  Large file, uploading part ' + progress + ' of ' + session.total_parts + ', please wait...' ;
                        setFiles(updatedFiles)

                        const firstPart = i === 0;
                        const finalPart = i === (session.total_parts-1);

                        if (!firstPart) {
                            rangeStart = rangeEnd + 1
                            rangeEnd = rangeEnd + session.part_size
                            if (finalPart){
                                rangeEnd = file.size -1
                            }
                        }

                        //const partBytes = finalPart ? allBytes.slice(rangeStart) : allBytes.slice(rangeStart, rangeStart + session.part_size); //for digest
                        const bodyPart = bodyFull.slice(rangeStart, rangeStart + session.part_size); //for body
                        const contentRange = "bytes " + rangeStart + "-" + rangeEnd + "/" + file.size; //<unit> <range-start>-<range-end>/<size>
                        debug && console.log ('part ', i+1 , 'contentRange: ', contentRange)

                        const partArrayBuffer = await window.crypto.subtle.digest("SHA-1", bodyPart);
                        const partDigest = 'sha=' + buf2Base64(partArrayBuffer)
                        debug && console.log ('part ', i+1 , 'partDigest: ', partDigest)

                        /* Note re. headers:
                        "content-range": "bytes 8388608-16777215/445856194", //The byte range of the chunk.  Must not overlap with the range of a part already uploaded this session.
                        "digest": "" //example sha=fpRyg5eVQletdZqEKaFlqwBXJzM=     The RFC3230 message digest of the chunk uploaded.  Only SHA1 is supported. The SHA1 digest must be Base64 encoded. The format of this header is as sha=BASE64_ENCODED_DIGEST.
                        */

                        const partRequest = {
                            method: 'PUT',
                            headers: {
                                "Content-Type": "application/octet-stream",
                                "Authorization": "Bearer " + props.userDetails.accessToken,
                                "Content-Range": contentRange,
                                "Digest": partDigest
                            },
                            body: bodyPart
                        };

                        debug && console.log ('Request for part ' + (i+1) + ' = ', partURL, 'partRequest=', partRequest);
                        const partResponse = await (fetch_retry(partURL,partRequest,3));
                        debug && console.log ('add part response = ', partResponse);
                        let partResponseJSON
                        if (partResponse.ok) {
                            partResponseJSON = await partResponse.json();
                            debug && console.log ('addPartResponseJSON = ', partResponseJSON);
                            partsArray.push(partResponseJSON.part)
                        } else {
                            partError = true
                            Promise.resolve(getErrorMessageFromResponse(partResponse, "uploading part " + progress + ' of ' + session.total_parts))
                                .then(message => {
                                    enqueueSnackbar(message, {variant: 'error'});
                                })
                        }

                        if (partError) {
                            break
                        }
                    }

                    if (partError) {
                        return null
                    } else {

                        debug && console.log('==========all chunks done for ' + file.name, "now commit then return file id...");
                        debug && console.log('partsArray=', partsArray);

                        const commitArrayBuffer = await window.crypto.subtle.digest("SHA-1", bodyFull);
                        const commitDigest = 'sha=' + buf2Base64(commitArrayBuffer);

                        const body = {
                            parts: partsArray,
                            metadata: metadataArray
                        }


                        const commitURL = window.REACT_APP_CONTENT_API_BASE_URL + window.REACT_APP_CONTENT_API_DOCUMENT + '/chunked/upload_sessions/' + session.id ;

                        const commitRequest = {
                            method: 'POST',
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer " + props.userDetails.accessToken,
                                "Digest": commitDigest
                            },
                            body: JSON.stringify(body)
                        };

                        debug && console.log('Commit session url = ', commitURL, 'BODY=', body, 'request=', commitRequest);

                        const commitResponse = await (fetch_retry(commitURL, commitRequest, 3));
                        debug && console.log('Commit session response = ', commitResponse);

                        try {
                            const commitResponseJSON = await commitResponse.json();
                            debug && console.log('commitResponseJSON = ', commitResponseJSON);
                            return commitResponseJSON
                        } catch (err) {
                            if (commitResponse) {
                                return commitResponse
                            } else {
                                //e.g. out of memory error
                                const errorMessage = err
                                enqueueSnackbar(errorMessage, {variant: 'error'});
                                return {message: err}
                            }

                        }
                    }
                }

            } else {

                //Upload via standard upload api (no chunking)

                //call readFileAsync to get content;
                let content = await readFileAsyncBase64(file);

                let body = {
                    content: content,
                    fileName: file.name,
                    metadata: metadataArray,
                    subFolders: subFolders
                };

                if (props.uploadConfig.watson) {
                    body.discoveryRequest = {
                        apiKey: window.REACT_APP_WATSON_APIKEY,
                        instanceId: window.REACT_APP_WATSON_INSTANCEID,
                        collectionId: window.REACT_APP_WATSON_COLLECTIONID,
                        environmentId: window.REACT_APP_WATSON_ENVIRONMENTID,
                    }
                }

                window.location.pathname.toLowerCase().includes("debug") && console.log ("body: " , body);

                const request = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + props.userDetails.accessToken
                    },
                    body: JSON.stringify(body)
                };

                debug && console.log ('Upload url= ', url, 'BODY=', body, 'request=', request);

                //upload to box
                await props.triggerRefreshAuthToken();
                let response = await (fetch(url,request));

                try {
                    if (response.ok) {
                        let data = await response.json();
                        debug && console.log ('response.json: ', data);
                        return data
                    } else {
                        //get error message and return that??
                        let errorDetails = {error: "placeholder"};
                        await getErrorMessageFromResponseAsync(response, '')
                            .then(message => {
                                console.log ('message = ', message)
                                errorDetails.message = message;
                            })
                        return (errorDetails)
                    }

                } catch(err) {
                    console.log ('exception', err)
                    enqueueSnackbar("Error " + response.status + " uploading file " + response.statusText, {variant: 'error'});
                    return {message: err}
                }
            }

        } catch(err) {
            window.location.pathname.toLowerCase().includes("debug") && console.log("processFile error: " , err);
            return {message: err};
        }
    }

    const doUploadAsync = () => {

        //wrap execution of asyncforEach in an async so that we can wait for all to be completed before showing confirmation
        const start = async () => {

            const debug = window.location.pathname.toLowerCase().includes("debug");

            //get folder metadata if required
            let parentFolderMetadataArray = [];

            let errorGettingMetadata = false;

            if (props.uploadConfig.setMetadataFromParentFolder) {

                debug && console.log ('setMetadataFromParentFolder');
                //add metadata specified to be applied from parent
                const setMetadataFromParentFolder = props.uploadConfig.setMetadataFromParentFolder;
                if (setMetadataFromParentFolder && setMetadataFromParentFolder.length > 0){

                    //get parent folder metadata
                    let getMetadataResponse = window.REACT_APP_FOLDER_SOURCE === "elastic" ?
                        await getFolderMetadataElastic() :
                        await getFolderMetadataBox();

                    let response = await getMetadataResponse;

                    debug && console.log ('getMetadata response = ' , response);

                    if (response) {
                        //extract the metadata we need from the response
                        //for each metadata template specified in config add item to array with templateKey, metadataKey and value
                        if ( window.REACT_APP_FOLDER_SOURCE === "elastic") {
                            for (let i=0; i < setMetadataFromParentFolder.length; i++) {
                                const templateKey = setMetadataFromParentFolder[i].templateKey
                                setMetadataFromParentFolder[i].metadataKeys.forEach(metadataKey => {
                                    const fieldConfig = getFieldConfig(props.metadataConfig, templateKey, metadataKey);
                                    let val = "";
                                    if (fieldConfig && fieldConfig.elasticField) {
                                        if (response.metadata[fieldConfig.elasticField] || response.metadata[fieldConfig.elasticField] === "" || response.metadata[fieldConfig.elasticField] === false) {
                                            val = response.metadata[fieldConfig.elasticField];
                                            if (fieldConfig.type === "date") {
                                                val = (val !== 0 && val !== "0" && val !== null) ? new Date(val) : val;
                                            }
                                            parentFolderMetadataArray.push({
                                                templateKey: setMetadataFromParentFolder[i].templateKey,
                                                metadataKey: metadataKey,
                                                value: val
                                            })
                                        }
                                    }
                                })
                            }

                        } else {
                            debug && console.log ('REACT_APP_FOLDER_SOURCE box');
                            //Process Box response
                            for (let i = 0; i < setMetadataFromParentFolder.length; i++) {
                                for (let r = 0; r < response.length; r++) {
                                    if (response[r]["$template"] === setMetadataFromParentFolder[i].templateKey) {
                                        //get metadata for each metadataKey listed
                                        setMetadataFromParentFolder[i].metadataKeys.forEach(metadataKey => {
                                            if (response[r][metadataKey]) {
                                                parentFolderMetadataArray.push({
                                                    templateKey: setMetadataFromParentFolder[i].templateKey,
                                                    metadataKey: metadataKey,
                                                    value: response[r][metadataKey]
                                                })
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    } else {
                        errorGettingMetadata = true
                    }
                }
            }

            if (!errorGettingMetadata) {

                let progressCounter = 0;
                let updatedFiles = [...files];

                await props.triggerRefreshAuthToken();
                await asyncForEach(
                    updatedFiles,
                    async (file) => {

                        const fileSizeStr = getReadableFileSizeString(file.size);

                        progressCounter = progressCounter + 1;
                        setUploadProgress(progressCounter)
                        file.statusMessage = "Uploading " + fileSizeStr  ;
                        file.statusIconClass = "greenAvatar";
                        setFiles(updatedFiles)

                        await processFile(file, parentFolderMetadataArray)
                            .then(result => {
                                window.location.pathname.toLowerCase().includes("debug") && console.log ('processFile result = ', result);
                                if (result) {
                                    if (result.id) {
                                        file.statusIconClass = "greenAvatar";
                                        if (result.sequence_id && result.sequence_id !== "" && parseInt(result.sequence_id) > 0 ) {
                                            file.statusIcon = "done_all";
                                            file.statusMessage = "Successfully uploaded " + fileSizeStr + ") as NEW VERSION of file, ID=" + result.id;
                                        } else {
                                            file.statusIcon = "done";
                                            file.statusMessage = "Successfully uploaded " + fileSizeStr + " file, ID = " + result.id;
                                        }

                                        return result.id
                                    } else {
                                        file.statusIcon = "error";
                                        file.statusIconClass = "redAvatar";

                                        Promise.resolve(getErrorMessageFromResponse(result, "uploading " + getReadableFileSizeString(file.size) + " file"))
                                            .then(message => {
                                                file.statusMessage = message
                                                return "0";
                                        })
                                    }
                                } else {
                                    window.location.pathname.toLowerCase().includes("debug") && console.log ("processFile result is null");
                                    file.statusIcon = "error";
                                    file.statusIconClass = "redAvatar";
                                    file.statusMessage = "Error uploading " + fileSizeStr + " file" ;
                                    return "0";
                                }
                            })
                            .then(id => {
                                file.id = id;
                            });

                        setFiles(updatedFiles)

                    });

                // All Done, update state with updatedfiles
                setIsUploadComplete(true);
                setResponse({success: true})
            } else {
                handleBack()
            }


        };

        //start upload
        //Validate first
        if (validateGenericFields()) {

            if (validateDocumentSpecificFields()) {

                //show confirmation step showing progress
                handleNext();
                start();
             }

        }

    };

    const updateFileList = (files) => {

        console.log ('*** updateFileList - ', props.uploadConfig)

        //Add rowID to prep data for adding to metadata table
        let defaultMetadata = {}
        props.uploadConfig.documentSpecificFields.forEach((field => {
            if (field.defaultToToday) {
                let dateVal = new Date()
                dateVal.setUTCHours(0, 0, 0, 0);
                defaultMetadata[field.templateKey+ "~" + field.metadataKey] = dateVal
            }
        }))

        counterMetadataTable = 0;
        let filesWithRowID = [];

        files.forEach((item, i) => {
            filesWithRowID.push(addRowIDToFile(item, defaultMetadata));
        });

        setFiles(filesWithRowID)

    }

    const handleClose = (event, reason) => {

        if (!(reason && reason === "backdropClick")) {

            setOpen(false)
            setActiveStep(0)
            setGenericMetadata({})
            setFiles([])
            setResponse({success: true, message: ""})
            setUploadProgress(0)
            setIsUploadComplete(false)

            props.closeAddDocDialog();
        }
    };

    const handleCancel = () => {
        setOpen(false)
        setActiveStep(0)
        setGenericMetadata({})
        setFiles([])
        setResponse({success: true, message: ""})
        setUploadProgress(0)
        setIsUploadComplete(false)

        props.cancelAddDocDialog();
    };

    const handleOnChangeGenericMetadata = (id, newValue) => {

        console.log('*** handleOnChangeGenericMetadata', id, newValue)

        const updatedGenericMetadata = {...genericMetadata};
        let val = newValue;
        if (val && typeof val === 'object') {
            console.log ('object')
            let dateVal = new Date(val)
            dateVal.setUTCHours(0,0,0,0);
            console.log ('dateVal=', dateVal)
            val = dateVal;
        }
        console.log('val=', val)
        updatedGenericMetadata[id] = val;
        console.log('updatedGenericMetadata=', updatedGenericMetadata)
        setGenericMetadata(updatedGenericMetadata)
    };

    const handleOnChangeDocumentMetadata = (id, newValue) => {

        //console.log ('handleOnChangeDocumentMetadata id=', id, 'newValue=', newValue);
        //const debug = window.location.pathname.toLowerCase().includes("debug")
        //input fields are named the same as the state properties so use this generic function to update the state properties
        //fields suffixed with _index

        let whichFile = Number(id.substring(id.indexOf("_")+1))-1;
        let stateProp = id.substring(0 , id.indexOf("_"));
        //debug && console.log ('stateProp = ', stateProp);
        const updatedFiles = [...files];

        let val = newValue;
        if (val && typeof val === 'object') {
            let dateVal = new Date(val)
            dateVal.setUTCHours(0,0,0,0);
            val = dateVal;
        }
        updatedFiles[whichFile].metadata[stateProp] = val;
        setFiles(updatedFiles)
    };

    const handleNext = () => {

        let maxWidth = "sm"
        if (activeStep + 1 === 1) {
            if (props.uploadConfig.documentSpecificFields.length <= 1) {
                maxWidth = "sm"
            } else if (props.uploadConfig.documentSpecificFields.length <= 2) {
                maxWidth = "md"
            } else if (props.uploadConfig.documentSpecificFields.length <= 4) {
                maxWidth = "lg"
            } else {
                maxWidth = "xl"
            }
        }

        setActiveStep(activeStep+1)
        setMaxWidth(maxWidth)
    };

    const handleBack = () => {
        let updatedMaxWidth = "sm"
        if (activeStep - 1 === 1) {
            if (props.uploadConfig.documentSpecificFields.length <= 1) {
                updatedMaxWidth = "sm"
            } else if (props.uploadConfig.documentSpecificFields.length <= 2) {
                updatedMaxWidth = "md"
            } else if (props.uploadConfig.documentSpecificFields.length <= 4) {
                updatedMaxWidth = "lg"
            } else {
                updatedMaxWidth = "xl"
            }
        }
        setActiveStep(activeStep - 1)
        setMaxWidth( updatedMaxWidth)
    };


    const { classes, actionConfig, ...other } = props;
    const singleFile = !!(actionConfig && actionConfig.filesLimit && actionConfig.filesLimit === 1);
    let steps = [], stepComponents = [];

    steps.push(singleFile ? "Select file to upload" : "Select files to upload");
    stepComponents.push(
        <SelectLocalDocumentStep
            classes={props.classes}
            updateFileList={updateFileList}
            files={files}
            actionConfig={props.actionConfig}
        />
    );
    steps.push("Enter metadata");
    stepComponents.push(
        <MetadataStep
            {...other}
            classes={props.classes}
            updateFileList={updateFileList}
            files={files}
            fixedMetadata={props.uploadConfig.fixedMetadata}
            genericMetadata={genericMetadata}
            fields={props.uploadConfig.documentSpecificFields}
            handleOnChangeDocumentMetadata={handleOnChangeDocumentMetadata}
            uploadProgress={uploadProgress}
            metadataConfig={props.metadataConfig}
            optionsConfig={props.optionsConfig}
            uploadConfig={props.uploadConfig}
            handleOnChangeGenericMetadata={handleOnChangeGenericMetadata}
            maxWidth={maxWidth}
            actionConfig={props.actionConfig}
        />
    );

    if(response.success) {
        stepComponents.push(
            <ConfirmationMessageStep classes={classes} files={files} uploadProgress={uploadProgress}
                                     isUploadComplete={isUploadComplete} actionConfig={props.actionConfig}/>)
    } else {
        stepComponents.push(<ErrorMessageStep/>);
    }


    let dialogTitle = actionConfig && actionConfig.label ? actionConfig.label : "Add File(s)";

    if (props.folderDetails && props.folderDetails.name) {
        dialogTitle = dialogTitle + " to " + props.folderDetails.name;
    }

    let dialogContentText = ""
    if (files && Array.isArray(files) && files.length === 1) {
        dialogContentText = files[0].name
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={maxWidth}
            height={"90vh"}
            disableEscapeKeyDown>

            {
                activeStep === steps.length ?

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    color={"secondary"}
                    sx={{position: 'absolute', right: 0, top: 0,}}
                    disabled = {!isUploadComplete}
                >
                    <CloseIcon />
                </IconButton> :

                    <IconButton
                        aria-label="close"
                        onClick={handleCancel}
                        color={"secondary"}
                        sx={{position: 'absolute', right: 0, top: 0,}}
                    >
                        <CloseIcon />
                    </IconButton>
            }

            <DialogTitle id="form-dialog-title">
                {dialogTitle}
                {
                    dialogContentText && <DialogContentText style={{marginBottom: '0px'}}>{dialogContentText}</DialogContentText>
                }


            </DialogTitle>
            <DialogContent>
                <div style={{width: '100%', display: 'block'}}>
                    <Stepper
                        activeStep={activeStep}
                        style={{padding: "24px"}}
                        orientation={"horizontal"}>
                        {steps.map((label, index) => {
                            const props = {};
                            const labelProps = {};
                            return (
                                <Step key={label} {...props}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>

                    {stepComponents[activeStep] || <div>Error: Step not configured...</div>}
                </div>
            </DialogContent>

            <DialogActions>
                <React.Fragment>
                    {
                        activeStep === steps.length ?
                            <Button onClick={handleClose}
                                    variant="contained"
                                    disabled = {!isUploadComplete}
                                    color="secondary">
                                {isUploadComplete ? "Close" : "Uploading..."}
                            </Button> :
                            <React.Fragment>
                                <Button variant="contained" color="grey" onClick={handleCancel}>Cancel</Button>&nbsp; &nbsp;
                                <Button variant="contained" color="secondary"
                                        disabled = {files.length === 0} //disable Next/Submit button if no files selected
                                        onClick={activeStep === steps.length - 1 ? doUploadAsync : handleNext}>
                                    {(activeStep === steps.length - 1 )? 'Submit' : 'Next'}
                                </Button>
                            </React.Fragment>
                    }
                </React.Fragment>
            </DialogActions>
        </Dialog>
    );
}

AddDocDialog.propTypes = {
    classes: PropTypes.object,
    userDetails: PropTypes.object.isRequired,
    uploadConfig: PropTypes.object.isRequired,
    metadataConfig: PropTypes.object.isRequired,
    optionsConfig: PropTypes.object.isRequired,
    cancelAddDocDialog: PropTypes.func.isRequired,
    closeAddDocDialog: PropTypes.func.isRequired,
    folderDetails: PropTypes.object,
    triggerRefreshAuthToken: PropTypes.func.isRequired,
    actionConfig: PropTypes.object.isRequired,
    indexes: PropTypes.array //required when folder source is elastic
};


export default (withStyles(styles, { withTheme: true })(AddDocDialog));
